var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 50,
    viewBox: "0 0 62 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6 0H35.9C35.1 0 34.4 -2.38419e-07 33.6 1.2L32.3 3H3.1C1.4 3 0 4.6 0 6.3V45.6C0 47.3 1.4 49 3.1 49H58.9C60.6 49 62 47.3 62 45.6V15.2V6.4V1.2C62 0.5 61.4 0 60.6 0Z",
    fill: "#C18205"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7 40.4C61.5 39.8 62 38.9 62 37.9V15.2V6.4V1.2C62 0.5 61.4 0 60.6 0H35.9C35.1 0 34.4 -2.38419e-07 33.6 1.2L32.3 3H3.1C1.5 3 0.2 4.3 0 5.8L60.7 40.4Z",
    fill: "#AA6E04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1001 7L60.7001 40.2C61.5001 39.6 62.0001 38.9 62.0001 37.9V15.2V9.6L58.2001 7H2.1001Z",
    fill: "#915A02"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57 7H5V45H57V7Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57 7H32V45H57V7Z",
    fill: "#EFEFEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62 47C62 48.7 60.6 50 58.9 50H3.1C1.4 50 0 48.7 0 47L1 15.3C1 13.6 2.4 12 4.1 12H58C59.7 12 61.1 13.6 61.1 15.3L62 47Z",
    fill: "#FFB000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6 48.4998L1.1 14.2998C1 14.6998 1 15.0998 1 15.4998L0 46.9998C0 48.6998 1.4 49.9998 3.1 49.9998H58.9C60 49.9998 61 49.3998 61.6 48.4998Z",
    fill: "#FFC200"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49 27H13C12.2 27 11.5 26.3 11.5 25.5C11.5 24.7 12.2 24 13 24H49C49.8 24 50.5 24.7 50.5 25.5C50.5 26.3 49.8 27 49 27Z",
    fill: "#FFB000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35H13C12.2 35 11.5 34.3 11.5 33.5C11.5 32.7 12.2 32 13 32H49C49.8 32 50.5 32.7 50.5 33.5C50.5 34.3 49.8 35 49 35Z",
    fill: "#FFB000"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8 43H13C12.2 43 11.5 42.3 11.5 41.5C11.5 40.7 12.2 40 13 40H39.9C40.7 40 41.4 40.7 41.4 41.5C41.3 42.3 40.6 43 39.8 43Z",
    fill: "#FFB000"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25H13C12.2 25 11.5 24.3 11.5 23.5C11.5 22.7 12.2 22 13 22H49C49.8 22 50.5 22.7 50.5 23.5C50.5 24.3 49.8 25 49 25Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49 33H13C12.2 33 11.5 32.3 11.5 31.5C11.5 30.7 12.2 30 13 30H49C49.8 30 50.5 30.7 50.5 31.5C50.5 32.3 49.8 33 49 33Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8 41H13C12.2 41 11.5 40.3 11.5 39.5C11.5 38.7 12.2 38 13 38H39.9C40.7 38 41.4 38.7 41.4 39.5C41.3 40.3 40.6 41 39.8 41Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.a22666ae.svg";
export { ForwardRef as ReactComponent };